import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "table-responsive my-2 font-12 border" }
const _hoisted_5 = { class: "table table-borderless mb-0" }
const _hoisted_6 = { class: "table-primary nowrap-text" }
const _hoisted_7 = { scope: "col" }
const _hoisted_8 = {
  key: 0,
  scope: "col"
}
const _hoisted_9 = { scope: "col" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 0,
  class: "badge badge-primary"
}
const _hoisted_13 = {
  key: 1,
  class: "badge badge-warning"
}
const _hoisted_14 = {
  key: 2,
  class: "badge badge-success"
}
const _hoisted_15 = {
  key: 3,
  class: "badge badge-danger"
}
const _hoisted_16 = { class: "text-nowrap" }
const _hoisted_17 = /*#__PURE__*/_createVNode("i", { class: "fa fa-paper-plane" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eye" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { colspan: "5" }
const _hoisted_22 = { class: "modal-wrap default-modal" }
const _hoisted_23 = {
  class: "modal fade",
  id: "deleteJobEstimation",
  "aria-labelledby": "view-modalLabel",
  "aria-hidden": "true"
}
const _hoisted_24 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_25 = { class: "modal-content" }
const _hoisted_26 = { class: "modal-header" }
const _hoisted_27 = {
  class: "modal-title",
  id: "view-modalLabel"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_29 = { class: "modal-body" }
const _hoisted_30 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_31 = { class: "text-danger" }
const _hoisted_32 = { class: "modal-footer" }
const _hoisted_33 = { class: "modal-wrap default-modal xl-size" }
const _hoisted_34 = {
  class: "modal fade",
  id: "showDetails",
  tabindex: -1,
  "aria-labelledby": "previewModalLabel",
  "aria-hidden": "true"
}
const _hoisted_35 = { class: "modal-dialog" }
const _hoisted_36 = { class: "modal-content" }
const _hoisted_37 = { class: "modal-header" }
const _hoisted_38 = /*#__PURE__*/_createVNode("i", { class: "fa fa-print" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("i", { class: "fa fa-download" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close",
  click: "detailsClose"
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_41 = { class: "modal-body bg-light" }
const _hoisted_42 = { class: "invoice-holder shadowed-box rounded p-3 bg-white" }
const _hoisted_43 = { class: "d-flex" }
const _hoisted_44 = { class: "flex-grow-1" }
const _hoisted_45 = /*#__PURE__*/_createVNode("div", { class: "invoice-logo" }, [
  /*#__PURE__*/_createVNode("img", {
    src: "https://convorally.com/wp-content/themes/convorally/assets/images/logo.png",
    alt: ""
  })
], -1)
const _hoisted_46 = { class: "invoice-address" }
const _hoisted_47 = { class: "uppercase-text" }
const _hoisted_48 = { class: "flex-shrink-0 mt-sm-0 mt-3" }
const _hoisted_49 = { class: "text-muted" }
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" 987654")
const _hoisted_51 = { class: "text-muted" }
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" help@convorally.com")
const _hoisted_53 = { class: "text-muted to-upper" }
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" www.convorally.com")
const _hoisted_55 = { class: "text-muted" }
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" 3362154530")
const _hoisted_57 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_58 = { class: "row" }
const _hoisted_59 = { class: "col-md-3" }
const _hoisted_60 = { class: "text-muted text-capitalize uppercase-text" }
const _hoisted_61 = { class: "col-md-3" }
const _hoisted_62 = { class: "text-muted text-capitalize uppercase-text" }
const _hoisted_63 = { class: "col-md-3" }
const _hoisted_64 = { class: "text-muted text-capitalize uppercase-text" }
const _hoisted_65 = { class: "table-responsive mt-4 font-12" }
const _hoisted_66 = { class: "table mb-0 table-borderless" }
const _hoisted_67 = { class: "nowrap-text" }
const _hoisted_68 = { class: "table-active" }
const _hoisted_69 = { scope: "col" }
const _hoisted_70 = { scope: "col" }
const _hoisted_71 = { scope: "col" }
const _hoisted_72 = { scope: "col" }
const _hoisted_73 = { scope: "col" }
const _hoisted_74 = { scope: "col" }
const _hoisted_75 = { scope: "col" }
const _hoisted_76 = {
  scope: "col",
  class: "text-end"
}
const _hoisted_77 = {
  colspan: "8",
  class: "pb-0"
}
const _hoisted_78 = { class: "mb-0" }
const _hoisted_79 = { class: "ps-3" }
const _hoisted_80 = { class: "desc-wrap" }
const _hoisted_81 = { class: "text-end" }
const _hoisted_82 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_83 = { class: "row justify-content-end" }
const _hoisted_84 = { class: "col-lg-3 col-md-9" }
const _hoisted_85 = { class: "total-box" }
const _hoisted_86 = { class: "table table-borderless table-nowrap align-middle mb-0 ms-auto" }
const _hoisted_87 = { scope: "row" }
const _hoisted_88 = { class: "text-end" }
const _hoisted_89 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_90 = {
  key: 0,
  class: "alert alert-danger mt-3"
}
const _hoisted_91 = { class: "mb-0" }
const _hoisted_92 = { class: "uppercase-text" }
const _hoisted_93 = { class: "row" }
const _hoisted_94 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_95 = { class: "signature-wrap my-2" }
const _hoisted_96 = { class: "signature-wrap my-2" }
const _hoisted_97 = { class: "alert alert-info mt-3" }
const _hoisted_98 = { class: "mb-0" }
const _hoisted_99 = { class: "modal-footer" }
const _hoisted_100 = /*#__PURE__*/_createVNode("i", { class: "fa fa-print" }, null, -1)
const _hoisted_101 = /*#__PURE__*/_createVNode("i", { class: "fa fa-download" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyData = _resolveComponent("EmptyData")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.state.ui.isLoading.getSmartContractList)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("table", _hoisted_5, [
          _createVNode("thead", _hoisted_6, [
            _createVNode("tr", null, [
              _createVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('estimation_no')), 1),
              (!_ctx.hasRole(['todo_member']))
                ? (_openBlock(), _createBlock("th", _hoisted_8, _toDisplayString(_ctx.$t('status')), 1))
                : _createCommentVNode("", true),
              _createVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('action')), 1)
            ])
          ]),
          (_ctx.state.data.smartContractLists.length > 0)
            ? (_openBlock(), _createBlock("tbody", _hoisted_10, [
                (!_ctx.hasOnlyRole('todo_member'))
                  ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.state.data.smartContractLists, (estimation, estimationIndex) => {
                      return (_openBlock(), _createBlock("tr", { key: estimationIndex }, [
                        _createVNode("td", null, [
                          _createVNode("p", null, [
                            _createTextVNode("# " + _toDisplayString(estimationIndex + 1) + " " + _toDisplayString(_ctx.$t('contract_based_on')) + " ", 1),
                            _createVNode("b", null, _toDisplayString(estimation.estimation? estimation.estimation.title:''), 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('job_estimation')) + ".", 1)
                          ])
                        ]),
                        (!_ctx.hasRole(['todo_member']))
                          ? (_openBlock(), _createBlock("td", _hoisted_11, [
                              (estimation.status == 0)
                                ? (_openBlock(), _createBlock("span", _hoisted_12, _toDisplayString(_ctx.$t('draft')), 1))
                                : _createCommentVNode("", true),
                              (estimation.status == 1)
                                ? (_openBlock(), _createBlock("span", _hoisted_13, _toDisplayString(_ctx.$t('sent')), 1))
                                : _createCommentVNode("", true),
                              (estimation.status == 2)
                                ? (_openBlock(), _createBlock("span", _hoisted_14, _toDisplayString(_ctx.$t('approved')), 1))
                                : _createCommentVNode("", true),
                              (estimation.status == 3)
                                ? (_openBlock(), _createBlock("span", _hoisted_15, _toDisplayString(_ctx.$t('declined')), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode("td", _hoisted_16, [
                          ((estimation.status == 0 && _ctx.hasRole(['owner', 'co-owner'])  && !(_ctx.projectStatus ==2)) || 
                                   (estimation.status == 3 && _ctx.hasRole(['owner', 'co-owner']) && !(_ctx.projectStatus ==2)))
                            ? (_openBlock(), _createBlock("a", {
                                key: 0,
                                href: "javascript:void(0)",
                                class: "btn btn-sm text-primary mr-1",
                                title: "send",
                                onClick: ($event: any) => (_ctx.sendSmartContract(estimation.uuid, estimation.estimation.uuid))
                              }, [
                                _hoisted_17,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('send')), 1)
                              ], 8, ["onClick"]))
                            : _createCommentVNode("", true),
                          ((estimation.status != 0 && _ctx.hasRole(['todo_payer'])) || 
                                   _ctx.hasRole(['owner', 'co-owner']))
                            ? (_openBlock(), _createBlock("a", {
                                key: 1,
                                href: "javascript:void(0)",
                                class: "btn btn-sm text-primary mr-1",
                                onClick: ($event: any) => (_ctx.gotoSmartContractPreview(estimation.uuid)),
                                title: "view details"
                              }, [
                                _hoisted_18,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('preview')), 1)
                              ], 8, ["onClick"]))
                            : _createCommentVNode("", true),
                          ((_ctx.hasRole(['todo_payer']) && estimation.status === 2) ||
                                   (_ctx.hasRole(['todo_member']) && estimation.status === 2) || 
                                   (_ctx.hasRole(['co-owner']) && estimation.status === 2) || 
                                   (_ctx.hasRole(['owner']) && estimation.status === 2))
                            ? (_openBlock(), _createBlock("a", {
                                key: 2,
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.redirectToPhasesDashboard(estimation.uuid)),
                                class: "btn btn-sm default-btn mr-1 outline"
                              }, [
                                _hoisted_19,
                                _createTextVNode(" " + _toDisplayString(_ctx.projectStatus === 2 ? _ctx.$t('go_to_workflow') : (!_ctx.hasRole(['owner']) ? _ctx.$t('go_to_workflow') : _ctx.$t('create_workflow'))), 1)
                              ], 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createBlock("tfoot", _hoisted_20, [
                _createVNode("tr", null, [
                  _createVNode("td", _hoisted_21, [
                    _createVNode(_component_EmptyData, {
                      title: _ctx.state.data.title,
                      heading: _ctx.state.data.heading
                    }, null, 8, ["title", "heading"])
                  ])
                ])
              ]))
        ])
      ])
    ]),
    _createVNode("div", _hoisted_22, [
      _createVNode("div", _hoisted_23, [
        _createVNode("div", _hoisted_24, [
          _createVNode("div", _hoisted_25, [
            _createVNode("div", _hoisted_26, [
              _createVNode("h5", _hoisted_27, _toDisplayString(_ctx.$t('delete_subitem')), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                "aria-label": "Close",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteJobEstimationClose()))
              }, [
                _hoisted_28
              ])
            ]),
            _createVNode("div", _hoisted_29, [
              _hoisted_30,
              _createVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('are_you_sure')) + "?", 1)
            ]),
            _createVNode("div", _hoisted_32, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteJobEstimationClose()))
              }, _toDisplayString(_ctx.$t('no')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn btn-danger",
                "data-dismiss": "modal",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deleteJobEstimation()))
              }, _toDisplayString(_ctx.$t('yes')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_33, [
      _createVNode("div", _hoisted_34, [
        _createVNode("div", _hoisted_35, [
          _createVNode("div", _hoisted_36, [
            _createVNode("div", _hoisted_37, [
              (_ctx.state.data.details.pdf_link)
                ? (_openBlock(), _createBlock("a", {
                    key: 0,
                    href: "javascript:void(0)",
                    class: "btn default-btn mr-2",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.downoadPdf(_ctx.state.data.details.pdf_link)))
                  }, [
                    _hoisted_38,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('print')), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.data.details.pdf_link)
                ? (_openBlock(), _createBlock("a", {
                    key: 1,
                    href: "javascript:void(0)",
                    class: "btn default-btn outline",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.downoadPdf(_ctx.state.data.details.pdf_link)))
                  }, [
                    _hoisted_39,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('download')), 1)
                  ]))
                : _createCommentVNode("", true),
              _hoisted_40
            ]),
            _createVNode("div", _hoisted_41, [
              _createVNode("div", _hoisted_42, [
                _createVNode("div", _hoisted_43, [
                  _createVNode("div", _hoisted_44, [
                    _hoisted_45,
                    _createVNode("div", _hoisted_46, [
                      _createVNode("p", null, [
                        _createVNode("strong", _hoisted_47, _toDisplayString(_ctx.$t('address')), 1)
                      ]),
                      _createVNode("p", null, _toDisplayString(_ctx.$t('address_sample')), 1),
                      _createVNode("p", null, _toDisplayString(_ctx.$t('city_state_zip')), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_48, [
                    _createVNode("p", null, [
                      _createVNode("span", _hoisted_49, _toDisplayString(_ctx.$t('registration_no')) + ":", 1),
                      _hoisted_50
                    ]),
                    _createVNode("p", null, [
                      _createVNode("span", _hoisted_51, _toDisplayString(_ctx.$t('email')) + ":", 1),
                      _hoisted_52
                    ]),
                    _createVNode("p", null, [
                      _createVNode("span", _hoisted_53, _toDisplayString(_ctx.$t('website')) + ":", 1),
                      _hoisted_54
                    ]),
                    _createVNode("p", null, [
                      _createVNode("span", _hoisted_55, _toDisplayString(_ctx.$t('contact_no')) + ":", 1),
                      _hoisted_56
                    ])
                  ])
                ]),
                _hoisted_57,
                _createVNode("div", _hoisted_58, [
                  _createVNode("div", _hoisted_59, [
                    _createVNode("p", null, [
                      _createVNode("strong", _hoisted_60, _toDisplayString(_ctx.$t('estimation_title')), 1)
                    ]),
                    _createVNode("p", null, _toDisplayString(_ctx.state.data.details.title), 1)
                  ]),
                  _createVNode("div", _hoisted_61, [
                    _createVNode("p", null, [
                      _createVNode("strong", _hoisted_62, _toDisplayString(_ctx.$t('estimation_no')), 1)
                    ]),
                    _createVNode("p", null, "#" + _toDisplayString(_ctx.state.data.details.no), 1)
                  ]),
                  _createVNode("div", _hoisted_63, [
                    _createVNode("p", null, [
                      _createVNode("strong", _hoisted_64, _toDisplayString(_ctx.$t('date')), 1)
                    ]),
                    _createVNode("p", null, _toDisplayString(_ctx.state.data.details.created_date), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_65, [
                  _createVNode("table", _hoisted_66, [
                    _createVNode("thead", _hoisted_67, [
                      _createVNode("tr", _hoisted_68, [
                        _createVNode("th", _hoisted_69, _toDisplayString(_ctx.$t('item')), 1),
                        _createVNode("th", _hoisted_70, _toDisplayString(_ctx.$t('description')), 1),
                        _createVNode("th", _hoisted_71, _toDisplayString(_ctx.$t('qty')), 1),
                        _createVNode("th", _hoisted_72, _toDisplayString(_ctx.$t('unit')), 1),
                        _createVNode("th", _hoisted_73, _toDisplayString(_ctx.$t('cost')), 1),
                        _createVNode("th", _hoisted_74, _toDisplayString(_ctx.$t('markup')), 1),
                        _createVNode("th", _hoisted_75, _toDisplayString(_ctx.$t('allowance')), 1),
                        _createVNode("th", _hoisted_76, _toDisplayString(_ctx.$t('total')), 1)
                      ])
                    ]),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.details.phases, (mainItem, mainItemIndex) => {
                      return (_openBlock(), _createBlock("tbody", { key: mainItemIndex }, [
                        _createVNode("tr", null, [
                          _createVNode("td", _hoisted_77, [
                            _createVNode("p", _hoisted_78, [
                              _createVNode("strong", null, _toDisplayString(mainItem.name), 1)
                            ])
                          ])
                        ]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(mainItem.sub_items, (item, itemIndex) => {
                          return (_openBlock(), _createBlock("tr", { key: itemIndex }, [
                            _createVNode("td", null, [
                              _createVNode("div", _hoisted_79, [
                                _createVNode("p", null, _toDisplayString(item.name), 1)
                              ])
                            ]),
                            _createVNode("td", null, [
                              _createVNode("div", _hoisted_80, [
                                _createVNode("p", null, _toDisplayString(item.description), 1)
                              ])
                            ]),
                            _createVNode("td", null, [
                              _createVNode("p", null, _toDisplayString(item.quantity), 1)
                            ]),
                            _createVNode("td", null, [
                              _createVNode("p", null, _toDisplayString(item.unit ? item.unit.name : ''), 1)
                            ]),
                            _createVNode("td", null, [
                              _createVNode("p", null, "$ " + _toDisplayString(item.cost), 1)
                            ]),
                            _createVNode("td", null, [
                              _createVNode("p", null, "$ " + _toDisplayString(item.markup), 1)
                            ]),
                            _createVNode("td", null, [
                              _createVNode("p", null, "$ " + _toDisplayString(item.allowance), 1)
                            ]),
                            _createVNode("td", _hoisted_81, [
                              _createVNode("p", null, "$ " + _toDisplayString(item.total), 1)
                            ])
                          ]))
                        }), 128))
                      ]))
                    }), 128))
                  ])
                ]),
                _hoisted_82,
                _createVNode("div", _hoisted_83, [
                  _createVNode("div", _hoisted_84, [
                    _createVNode("div", _hoisted_85, [
                      _createVNode("table", _hoisted_86, [
                        _createVNode("tbody", null, [
                          _createVNode("tr", null, [
                            _createVNode("th", _hoisted_87, _toDisplayString(_ctx.$t('total_amount')), 1),
                            _createVNode("th", _hoisted_88, "$ " + _toDisplayString(_ctx.state.data.details.total), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _hoisted_89,
                (_ctx.state.data.details.declined_customers && _ctx.state.data.details.declined_customers.length > 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_90, [
                      _createVNode("p", _hoisted_91, [
                        _createVNode("strong", _hoisted_92, _toDisplayString(_ctx.$t('declined_reason')) + ": ", 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.state.data.details.declined_customers[0].reason), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_93, [
                  (_ctx.state.data.details.signature)
                    ? (_openBlock(), _createBlock("div", _hoisted_94, [
                        _createVNode("p", null, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('senders_signature')), 1)
                        ]),
                        _createVNode("div", _hoisted_95, [
                          _createVNode("img", {
                            src: _ctx.state.data.details.signature,
                            alt: ""
                          }, null, 8, ["src"])
                        ]),
                        _createVNode("p", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('date')) + ": ", 1),
                          _createVNode("strong", null, _toDisplayString(_ctx.state.data.details.signature_date), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.details.singed_customers, (customer, customerIndex) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "col-md-4",
                      key: customerIndex
                    }, [
                      _createVNode("p", null, [
                        _createVNode("strong", null, _toDisplayString(customer.name ? customer.name : customer.email), 1)
                      ]),
                      _createVNode("div", _hoisted_96, [
                        _createVNode("img", {
                          src: customer.signature,
                          alt: ""
                        }, null, 8, ["src"])
                      ]),
                      _createVNode("p", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('date')) + ": ", 1),
                        _createVNode("strong", null, _toDisplayString(customer.signaute_date), 1)
                      ])
                    ]))
                  }), 128))
                ]),
                _createVNode("div", _hoisted_97, [
                  _createVNode("p", _hoisted_98, [
                    _createVNode("strong", null, _toDisplayString(_ctx.$t('note')), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.state.data.note), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_99, [
              (_ctx.state.data.details.pdf_link)
                ? (_openBlock(), _createBlock("a", {
                    key: 0,
                    href: "javascript:void(0)",
                    class: "btn default-btn mr-2",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.downoadPdf(_ctx.state.data.details.pdf_link)))
                  }, [
                    _hoisted_100,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('print')), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.data.details.pdf_link)
                ? (_openBlock(), _createBlock("a", {
                    key: 1,
                    href: "javascript:void(0)",
                    class: "btn default-btn outline",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.downoadPdf(_ctx.state.data.details.pdf_link)))
                  }, [
                    _hoisted_101,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('download')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}